export default [
    {
        path: "/admin/driver/zones",
        name: "zone",
        meta: { requiresAuth: true },
        component: () => import("@/pages/driver/zone/index.vue")
    },

    {
        path: "/admin/driver/zones/create",
        name: "zone-create",
        meta: { requiresAuth: true },
        component: () => import("@/pages/driver/zone/create.vue")
    },

    {
        path: "/admin/driver/zones/assign-driver",
        name: "assign-driver",
        meta: { requiresAuth: true },
        component: () => import("@/pages/driver/zone/assign-driver.vue")
    },

    {
        path: "/admin/driver/zones/:id/edit",
        name: "zone-edit",
        meta: { requiresAuth: true },
        component: () => import("@/pages/driver/zone/edit.vue")
    }
];
